import { render, staticRenderFns } from "./InvoiceExtractGuide.vue?vue&type=template&id=6495a126&scoped=true"
import script from "./InvoiceExtractGuide.vue?vue&type=script&lang=js"
export * from "./InvoiceExtractGuide.vue?vue&type=script&lang=js"
import style0 from "./InvoiceExtractGuide.vue?vue&type=style&index=0&id=6495a126&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6495a126",
  null
  
)

export default component.exports